import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgHandenWassenExtra = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 40 40"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      fill="#00215B"
      fillRule="evenodd"
      d="M22.4 5.5h6.83v1h-6.829A1.91 1.91 0 0 0 20.5 8.401v4.519h-1V8.398A2.91 2.91 0 0 1 22.398 5.5z"
      clipRule="evenodd"
    />
    <path
      fill="#00C5F2"
      d="M15.22 12.92h9.57a4.45 4.45 0 0 1 4.45 4.45v17.92a.71.71 0 0 1-.71.71h-17a.71.71 0 0 1-.71-.71V17.37a4.45 4.45 0 0 1 4.45-4.45z"
    />
    <path
      fill="#00C5F2"
      d="M21.64 10.62h-3.28c-.37 0-.67.3-.67.67v3.17c0 .37.3.67.67.67h3.28c.37 0 .67-.3.67-.67v-3.17c0-.37-.3-.67-.67-.67"
    />
    <path
      fill="#85E3F9"
      d="M31.87 13.36a2.64 2.64 0 0 1-5.28 0c0-1.48 2.64-5.32 2.64-5.32s2.64 3.84 2.64 5.32M22.7 37.99a5.07 5.07 0 1 0 0-10.14 5.07 5.07 0 0 0 0 10.14"
    />
    <path
      fill="#85E3F9"
      d="M28.18 38.05a3.08 3.08 0 1 0 0-6.16 3.08 3.08 0 0 0 0 6.16M7.61 37.49a2.18 2.18 0 1 0 0-4.36 2.18 2.18 0 0 0 0 4.36M8.01 30.27a2.53 2.53 0 1 0 0-5.06 2.53 2.53 0 0 0 0 5.06M18.48 30.39a3.8 3.8 0 1 0 0-7.6 3.8 3.8 0 0 0 0 7.6M13.73 22.66a1.27 1.27 0 1 0 0-2.54 1.27 1.27 0 0 0 0 2.54M8.84 23.2a.65.65 0 1 0 0-1.3.65.65 0 0 0 0 1.3M28.96 30.9a.65.65 0 1 0 0-1.3.65.65 0 0 0 0 1.3M10.69 19.12a.65.65 0 1 0 0-1.3.65.65 0 0 0 0 1.3M22.76 23.87a.65.65 0 1 0 0-1.3.65.65 0 0 0 0 1.3M16.25 11.31a.65.65 0 1 0 0-1.3.65.65 0 0 0 0 1.3M17.94 20.36a1.27 1.27 0 1 0 0-2.54 1.27 1.27 0 0 0 0 2.54"
    />
    <path
      fill="#85E3F9"
      d="M12.36 24.16a1.27 1.27 0 1 0 0-2.54 1.27 1.27 0 0 0 0 2.54M24.43 26.56a1.27 1.27 0 1 0 0-2.54 1.27 1.27 0 0 0 0 2.54M28.63 25.29a1.27 1.27 0 1 0 0-2.54 1.27 1.27 0 0 0 0 2.54M14.09 39a6.34 6.34 0 1 0 0-12.68 6.34 6.34 0 0 0 0 12.68"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgHandenWassenExtra);

export default ForwardRef;
